import { render } from "./TasksAll.vue?vue&type=template&id=7d7e0558"
import script from "./TasksAll.vue?vue&type=script&lang=js"
export * from "./TasksAll.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__